
import { Vue, Component, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';
import moment from 'moment';
import { getCurrentMonth } from '@/common/utils';
import { AuthEnum } from '@/services/permission.service';


@Component({})
export default class ShopInspectionData extends Vue {
  moment = moment;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  AuthEnum = AuthEnum;

  filterForm: any = {
    month: '',
    dept_id: undefined,
    group_id: undefined,
    agent_name: '',
  };
  columns = [
    {
      title: '部',
      dataIndex: 'dept_name',
      key: 'dept_name',
      align: 'center',
    },
    {
      title: '组',
      dataIndex: 'group_name',
      key: 'group_name',
      align: 'center',
    },
    {
      title: '组员',
      dataIndex: 'agent_name',
      key: 'agent_name',
      align: 'center',
    },
    {
      title: '应巡店次数',
      dataIndex: 'shop_inspection_target_quantity',
      key: 'shop_inspection_target_quantity',
      align: 'center',
    },
    {
      title: '已完成巡店次数',
      dataIndex: 'shop_inspection_count',
      key: 'shop_inspection_count',
      align: 'center',
    },
    {
      title: '完成度',
      dataIndex: 'completionRate',
      key: 'completionRate',
      align: 'center',
      customRender: (text: any, record: any) => {
        return `${(record.shop_inspection_count / record.shop_inspection_target_quantity * 100).toFixed(2)}%`;
      },
    },
  ];
  data = [];

  dept_list: any = [];

  group_list: any = [];

  module: any = '';

  @Watch('$route.query')
  onRouteChange() {
    const { page, pageSize, module, month, dept_id, group_id, agent_name } = this.$route.query;
    const queryParams: any = {
      page: page || 1,
      pageSize: pageSize || 10,
      module: module || '',
    };
    this.module = module || '';
    if (month) {
      queryParams.month = month;
      this.filterForm.month = month;
    } else {
      queryParams.month = getCurrentMonth();
      this.filterForm.month = getCurrentMonth();
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
      this.filterForm.dept_id = +dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
      this.filterForm.group_id = +group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
      this.filterForm.agent_name = agent_name;
    }
    // this.getQueryParams();
    this.getList(queryParams);
  }

  async getList(val: any) {
    const res = await this.workbenchesService.getQuickEntrance(val, this.$el);
    this.data = res;
  }

  exportData() {
    const { month, dept_id, group_id, agent_name } = this.filterForm;
    const queryParams: any = {
      module: this.module,
      export: 1,
    };
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    this.workbenchesService.getQuickEntranceExport(queryParams, '巡店数据');
  }

  reset() {
    this.filterForm = {
      month: '',
      dept_id: '',
      group_id: '',
      agent_name: '',
    };
    this.getQueryParams();
  }

  refresh() {
    // console.log('refresh');
  }

  changeMonth(val: any) {
    const year = val._d.getFullYear(); // 获取当前年份，例如：2021
    let month: any = Number(val._d.getMonth()) + 1; // 获取当前月份，注意需要加1，例如：9
    if (month < 10) {
      month = `0${month}`;
    }
    const _d = `${year}-${month}`;
    this.filterForm.month = _d;
  }

  async getDeptInfo() {
    const res = await this.workbenchesService.getDeptInfo();
    this.dept_list = res;
    const { dept_id } = this.$route.query;
    if (!dept_id) return;
    const deptId = Number(dept_id);
    this.group_list = this.dept_list.find((item: any) => item.dept.id === deptId).group;
  }

  selectOption(val: any) {
    this.group_list = this.dept_list.find((res: any) => res.dept.id === val).group;
    this.filterForm.group_id = undefined;
  }

  search() {
    this.getQueryParams();
  }

  getQueryParams() {
    const { month, dept_id, group_id, agent_name } = this.filterForm;
    const queryParams: any = {
      module: this.module,
    };
    if (month) {
      queryParams.month = month;
    }
    if (dept_id) {
      queryParams.dept_id = dept_id;
    }
    if (group_id) {
      queryParams.group_id = group_id;
    }
    if (agent_name) {
      queryParams.agent_name = agent_name;
    }
    queryParams.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query: queryParams,
    });
  }


  mounted() {
    // const columns = warkLabel.init('PerformanceTargetConfiguration');
    this.getDeptInfo();
    this.onRouteChange();
    const obj: any = {
      dept_name: 'dept_id',
      dept_manager: 'dept_id',
      dept_gmv_target: 'dept_id',
      dept_gmv: 'dept_id',
      dept_gmv_ratio: 'dept_id',
      group_manager: 'group_id',
      group_gmv_target: 'group_id',
      group_gmv: 'group_id',
      group_gmv_ratio: 'group_id',
      group_name: 'group_id',
    };
    this.columns.forEach((res: any) => {
      if (Object.prototype.hasOwnProperty.call(obj, res.dataIndex)) {
        res.customRender = (text: any, row: any, index: any) => {
          return this.customRender(text, row, index, obj[res.dataIndex]);
        };
      }
    });
  }

  customRender(text: any, row: any, index: any, column: any) {
    const prevRow: any = this.data[index - 1];
    if (prevRow && prevRow[column] === row[column]) {
      return {
        children: text,
        attrs: {
          rowSpan: 0,
        },
      };
    }
    let rowSpan = 1;
    const _i: number = index;
    for (let i = _i + 1; i < this.data.length; i++) {
      const currentRow: any = this.data[i];
      if (currentRow[column] === row[column]) {
        rowSpan++;
      } else {
        break;
      }
    }
    return {
      children: text,
      attrs: {
        rowSpan,
      },
    };
  }

  back() {
    this.$router.push({ name: 'workbenches.index' });
  }
}
